import { Site } from "./sites.model";

export class Email {
    id: number;
    type: string;
    email1: string;
    email2: string;
    site: Site;

    constructor() { 
        this.site = new Site();
    }
}

export class EmailForm {
    id: number;
    type: string;
    email1: string;
    email2: string;
    site: number;

    constructor() { }
}